import { getRetailerActiveMemberships } from "@faire/help-center-utils/serialized-data/getRetailer";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import { GoToMembershipSettingsCTA } from "./ctas";
export var CancelMembershipIA = function CancelMembershipIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  var _getRetailerActiveMem;
  var membershipRenewalDate = (_getRetailerActiveMem = getRetailerActiveMemberships()) === null || _getRetailerActiveMem === void 0 ? void 0 : _getRetailerActiveMem.current_period_end_at;
  if (!membershipRenewalDate) {
    return CANCEL_MEMBERSHIP_GENERAL(strictLocalize);
  }
  return CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO(strictLocalize, membershipRenewalDate);
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToMembershipSettingsCTA(strictLocalize);
};
var CANCEL_MEMBERSHIP_GENERAL = function CANCEL_MEMBERSHIP_GENERAL(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_CANCEL_MEMBERSHIP(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOUR_MEMBERSHIP_RENEWS_ON(strictLocalize)];
    }
  };
};
var CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO = function CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO(strictLocalize, membershipRenewalDate) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_CANCEL_MEMBERSHIP(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE(strictLocalize, membershipRenewalDate)];
    }
  };
};
var HOW_TO_CANCEL_MEMBERSHIP = function HOW_TO_CANCEL_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "64Yg7u",
    defaultMessage: [{
      "type": 0,
      "value": "Como cancelar a sua subscrição Insider"
    }]
  });
};
var IF_YOUR_MEMBERSHIP_RENEWS_ON = function IF_YOUR_MEMBERSHIP_RENEWS_ON(strictLocalize) {
  return strictLocalize({
    id: "2lMZeQ",
    defaultMessage: [{
      "type": 0,
      "value": "Se quiser cancelar a subscrição Insider, pode fazê-lo no separador \"Subscrição Insider\" nas definições de conta. Se decidir cancelar antes da data do próximo débito, a subscrição irá terminar no final do ciclo de faturação em curso. Por exemplo, se a renovação da subscrição estiver agendada para 30 de junho e cancelar a 15 de junho, o acesso continuará até 30 de junho. Terá acesso aos benefícios do Insider até essa data."
    }]
  });
};
var IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE = function IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE(strictLocalize, renewalDate) {
  return strictLocalize({
    id: "/4fXeB",
    defaultMessage: [{
      "type": 0,
      "value": "Se quiser cancelar a subscrição Insider, pode fazê-lo no separador \"Subscrição Insider\" nas definições de conta. Se decidir cancelar a subscrição antes da data do próximo débito, a subscrição irá terminar no final do ciclo de faturação em curso. Por exemplo, se cancelar a subscrição antes de "
    }, {
      "type": 1,
      "value": "renewalDate"
    }, {
      "type": 0,
      "value": ", a mesma não será renovada, mas continuará a ter acesso aos benefícios do Insider até essa data."
    }]
  }, {
    renewalDate: intlDate(renewalDate, "MMMM d")
  });
};